import { useMemo } from 'react';
import { BudgetRecipientEnum } from '../../createAndEdit/types';
import { BudgetStatusEnum } from '../../../../enums/budgetStatus';

interface IUseFactoryDetailJourneyParams {
  userProfile?: BudgetRecipientEnum | string;
  budgetRecipient?: BudgetRecipientEnum | string;
  budgetStatus?: BudgetStatusEnum | string;
  isLastVersion?: boolean;
}

export const useFactoryDetailJourney = (params: IUseFactoryDetailJourneyParams) => {
  const { userProfile, budgetRecipient, budgetStatus } = params;

  const isFactory = userProfile === BudgetRecipientEnum.TOWER;

  const isApproved = useMemo(() => {
    return budgetStatus === BudgetStatusEnum.APPROVED || budgetStatus === 'Aprovado';
  }, [budgetStatus]);

  const shouldShowActions = useMemo(() => {
    if(!params.isLastVersion) {
      return false;
    }

    if (!budgetRecipient || !userProfile) {
      return false;
    }
    return budgetRecipient === userProfile;
  }, [budgetRecipient, userProfile, isApproved]);

  const shouldShowCloseButton = useMemo(() => {
    return !isApproved && !shouldShowActions;
  }, [isApproved, shouldShowActions]);

  const shouldShowCloseIcon = useMemo(() => {
    return !isApproved;
  }, [isApproved]);

  return {
    isFactory,
    shouldShowActions,
    shouldShowCloseButton,
    shouldShowCloseIcon,
    shouldShowCounterProposal: false,
    isApproved,
  };
};

